import { render, staticRenderFns } from "./inviteAdd.vue?vue&type=template&id=062ad489&scoped=true"
import script from "./inviteAdd.vue?vue&type=script&lang=js"
export * from "./inviteAdd.vue?vue&type=script&lang=js"
import style0 from "./inviteAdd.vue?vue&type=style&index=0&id=062ad489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ad489",
  null
  
)

export default component.exports